import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserFollowedDataObjectGroupValidFormDataSchema.translations.json';
import { DataObjectGroupType } from '../../../../dataobject/types';

const { addTranslations, t } = i18nNsFactory(
  'user-followed-data-object-group-valid-form-data-schema',
);
addTranslations(translations);

export const UserFollowedDataObjectGroupBaseValidFormDataSchema = z.object({
  dataObjectGroupId: z.number({
    errorMap: () => ({
      message: t('validation.dataObjectGroupId.required'),
    }),
  }),
});

export const UserFollowedDataObjectGroupValidFormDataSchema =
  z.discriminatedUnion('groupType', [
    UserFollowedDataObjectGroupBaseValidFormDataSchema.extend({
      groupType: z.literal(DataObjectGroupType.I),
      periodSkipCount: z.number({
        errorMap: () => ({
          message: t('validation.periodSkipCount.required'),
        }),
      }),
    }),
    UserFollowedDataObjectGroupBaseValidFormDataSchema.extend({
      groupType: z.literal(DataObjectGroupType.O),
      periodSkipCount: z.number().optional(),
    }),
  ]);
